import React = require("react");
import SvgIcon from "material-ui/SvgIcon";

export class TableInsert extends React.Component<__MaterialUI.SvgIconProps, {}> {

    static contextTypes = {
        muiTheme: React.PropTypes.object,
    };

    context: {
        muiTheme: __MaterialUI.Styles.MuiTheme
    };

    render() {
        const style1: React.CSSProperties = {
            fillRule: 'evenodd'
        };
        const style2: React.CSSProperties = {
            fillRule: 'evenodd',
            fill: this.context.muiTheme.palette.iconPositiveColor,
        };
        return (
            <SvgIcon {...this.props}>
                <path style={style1} d="M4,4H18V8H4V4ZM4,16H18v4H4V16Z"/>
                <path style={style2} d="M9,15L5,12,9,9v6Zm2-5H21v4H11V10Z"/>
            </SvgIcon>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/custom-components/svg-icons/table/TableInsert.tsx
 **/